export default __webpack_public_path__ + "static/media/product8.3a912d2f.jpg";